<template>
  <app-modal width="90%" name="setting-modal" :title="title" @before-open="beforeOpen" hide-footer
    :bodyClass="customStyleByComponent.body">
    <div class="row setting-modal-content">
      <div class="col-lg-3 setting-modal-sidebar" :class="customStyleByComponent.sidebar">
        <ul class="tabs">
          <li v-for="(tab, index) in tabs" :key="index" @click="onClickTab(tab.key)"
            :class="{ 'active': activeTab === tab.key }" class="tab-item">
            <template v-if="tab.icon.endsWith('.png') || tab.iconActive">
              <img :src="activeTab === tab.key && tab.iconActive ? tab.iconActive : tab.icon" alt="Tiktok"
                class="icon-png" />
            </template>
            <template v-else>
              <i :class="tab.icon"></i>
            </template>
            <span>{{ $t(tab.label) }}</span>
          </li>
        </ul>
      </div>
      <div class="col-lg-9">
        <component :is="activeComponent"></component>
      </div>
    </div>
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import CompanySetting from '@/portal-components/setting/company-setting';
import InvoiceSetting from '@/portal-components/setting/invoice-setting';
import UserSetting from '@/portal-components/setting/user-setting';
import RuleSetting from '@/portal-components/setting/rule-setting';
import LicenseSetting from '@/portal-components/setting/license-setting';
import CompanyTaxAccountSetting from '@/portal-components/setting/company-tax-account-setting';
import DirectoryProxy from '../../store/proxies/directory-proxy';
import ToastUtils from '@/utils/toast';


const TABS = [
  { key: 'COMPANY_INFO', label: 'user.companyInformation', icon: 'fal fa-building' },
  { key: 'INVOICE_SETTING', label: 'user.invoiceSetting', icon: 'fal fa-cog' },
  { key: 'COMPANY_TAX_ACCOUNT', label: 'user.taxAuthorityAccount', icon: 'fal fa-university' },
  { key: 'USER', label: 'user.accountManagement', icon: 'fal fa-user' },
  { key: 'REPORT', label: 'user.report', icon: 'fal fa-file-chart-line' },
  { key: 'LICENSE', label: 'user.purchasedPackage', icon: 'fal fa-file-certificate' },
  { key: 'CONNECT_TIKTOK', label: 'user.connect_tiktok', icon: '/images/icon-tiktok.png', iconActive: '/images/icon-active-tiktok.png' },
];

export default {
  name: 'SettingModal',
  components: {
    CompanyTaxAccountSetting,
    LicenseSetting,
    RuleSetting,
    UserSetting,
    CompanySetting,
    InvoiceSetting,
    AppModal,
  },
  data() {
    return {
      title: this.$t('user.generalSettings'),
      activeTab: 'COMPANY_INFO',
      tabs: TABS,
      loading: false,
      isTiktokConnecting: false,
    };
  },
  computed: {
    activeComponent() {
      switch (this.activeTab) {
        case 'COMPANY_INFO':
          return CompanySetting;
        case 'INVOICE_SETTING':
          return InvoiceSetting
        case 'COMPANY_TAX_ACCOUNT':
          return CompanyTaxAccountSetting;
        case 'USER':
          return UserSetting;
        case 'REPORT':
          return RuleSetting;
        case 'LICENSE':
          return LicenseSetting;
        default:
          return CompanySetting;
      }
    },
    customStyleByComponent() {
      switch (this.activeTab) {
        case 'COMPANY_INFO':
        case 'INVOICE_SETTING':
          return {
            body: 'pt-0 pb-4 pl-4 pr-4',
            sidebar: 'pt-4'
          }
        default:
          return {
            body: '',
            sidebar: ''
          }
      }
    }
  },
  methods: {
    beforeOpen(params) {
      if (params.activeTab) {
        this.activeTab = params.activeTab;
      }
    },
    openCenteredPopup(url, width = 800, height = 600) {
      const left = (window.screen.width / 2) - (width / 2);
      const top = (window.screen.height / 2) - (height / 2);

      return window.open(
        url,
        '_blank',
        `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=yes`
      );
    },
    async onClickTab(tab) {
      this.activeTab = tab;

      if (tab === 'CONNECT_TIKTOK') {

        if (this.isTiktokConnecting) return;

        this.isTiktokConnecting = true;

        try {
          this.loading = true;
          const res = await new DirectoryProxy().connectDirTiktok();
          if (res.success && res.data.authorize_url) {
            const popup = this.openCenteredPopup(res.data.authorize_url, 800, 600);

            const timer = setInterval(() => {
              if (popup.closed) {
                clearInterval(timer);
                this.activeTab = 'COMPANY_INFO';
              }
            }, 500);
          } else {
            ToastUtils.showToast('error', 'Không lấy được link TikTok');
          }
        } catch (err) {
          console.error(err);
          ToastUtils.showToast('error', 'Lỗi kết nối TikTok');
        } finally {
          this.loading = false;
          this.isTiktokConnecting = false;
        }
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.setting-modal-content {
  .setting-modal-sidebar {
    padding-left: 0;
    height: fit-content;
    position: sticky;
    top: 0;

    ul.tabs {
      margin: 0;
      padding: 0;
      list-style: none;

      // height: 100%;
      li {
        height: 35px;
        border-left: 3px solid transparent;
        margin: 8px 0;
        padding: 4px 18px;
        display: flex;
        justify-content: start;
        align-items: center;
        transition: background 0.3s, color 0.3s;

        i {
          font-size: 18px;
          width: 34px;
          padding-right: 8px;
          text-align: center;
        }

        img {
          width: 35px;
          height: 25px;
          padding-right: 8px;
        }

        span {
          font-size: 14px;
        }

        &:hover,
        &:focus,
        &.active {
          background: rgba(217, 217, 217, 0.4);
          border-radius: 0 0.5rem 0.5rem 0;
          cursor: pointer;
        }

        &.active {
          color: #005DCA;
          font-weight: 600;
          border-left: 3px solid #005DCA;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/portal-components/setting/setting-modal.vue